import { ModalState } from 'kinetic-angular';
import { LeaveConfirmModalState } from '../services/shared/shared-interface';

export class ConfirmLeavePageFactory
{
	public static buildconfirmLeavePageModalState(): ModalState 
	{
		return {
			hidden: true,
			label: '',
			buttons: [
				{ label: '', disabled: false, cssClass: 'btn-secondary', iconPath: '' },
				{ label: '', disabled: false, cssClass: 'btn-black' }
			],
			cssClass: 'confirmLeavePageModal'
		};
	}

	public static buildConfirmLeavePageAEMLabels(): LeaveConfirmModalState 
	{
		return {
			heading: '',
			headingSub: '',
			stay: '',
			leave: '',
			closeIcon: {
				iconPath: '',
				altText: ''
			}
		};
	}
}
